import { createContext, Dispatch, useContext } from "react";
import {  Section } from "../..";
import { Graph_QL } from "../../../../Services";
import { SystemTypes } from "../../../../Definitions";

/* eslint-disable */
enum IModalContextEnum {
  currentSectionLevel = "currentSectionLevel",
  section = "section",
  systemType = "systemType"
}
/* eslint-enable */

export type IModalContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  systemType: SystemTypes;
  currentSectionLevel: number;
  section: Section;
  error: {Elementid:number, errorText:string};
};

export type ModalDispatcherT = Deep_Partial<IModalContext>;

type ModalContexter = {
  state: IModalContext,
  dispatch: Dispatch<ModalDispatcherT>
}

export const ModalContext = createContext<ModalContexter | undefined>(undefined);

export function ModalReducer(state: IModalContext, action: ModalDispatcherT) {
  let ResultState = state;
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IModalContextEnum.currentSectionLevel:
        ResultState = Object.assign({}, ResultState, {
          currentSectionLevel: payload
        } as ModalDispatcherT)
        break;
      case IModalContextEnum.section:
        let newSection_State = Object.assign({}, ResultState.section, payload)
        if (newSection_State && newSection_State.columns && typeof(newSection_State.columns) === "number") newSection_State.columns = Number(newSection_State.columns)
        if (newSection_State && newSection_State.rows && typeof(newSection_State.rows)=== "number") newSection_State.rows = Number(newSection_State.rows)
        if (newSection_State && newSection_State.startNumber && typeof(newSection_State.startNumber)=== "number") newSection_State.startNumber = Number(newSection_State.startNumber)
        
        ResultState = Object.assign({}, ResultState, {
          section: newSection_State
        } as ModalDispatcherT)
        break;
        case "error":
          ResultState = { ...ResultState, error: payload as IModalContext["error"] };
        break;
      default:
        console.error(`Unhandled action type: ${type}`)
        break
    }
  })
  return ResultState;
}

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};